import { render, staticRenderFns } from "./affectation-mgt-person.vue?vue&type=template&id=7b6facc8&"
import script from "./affectation-mgt-person.vue?vue&type=script&lang=ts&"
export * from "./affectation-mgt-person.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports